import { Box, BoxProps } from 'reakit';
import cn from 'classnames';

export default function Container({ children, className, ...props }: BoxProps) {
  return (
    <Box className={cn(`max-w-6xl mx-auto px-6`, className)} {...props}>
      {children}
    </Box>
  );
}
